"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ChevronRight, type LucideIcon } from "lucide-react";
import { cn } from "@workspace/ui/lib/utils";

interface SidebarItemProps {
  icon: LucideIcon;
  label: string;
  href: string;
  onClick?: () => void;
  active?: boolean;
}

export function SidebarItem({
  icon: Icon,
  label,
  href,
  onClick,
  active,
}: SidebarItemProps) {
  const pathname = usePathname();
  const isActive =
    active ?? (pathname === href || pathname.startsWith(`${href}/`));

  return (
    <Link
      href={href}
      prefetch={false}
      onClick={onClick}
      className={cn(
        "group flex items-center justify-between rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
        isActive
          ? "bg-primary text-primary-foreground"
          : "text-muted-foreground hover:bg-muted hover:text-foreground",
      )}
    >
      <div className="flex items-center gap-3">
        <Icon
          size={18}
          className="transition-colors group-hover:text-foreground"
        />
        <span>{label}</span>
      </div>
      <ChevronRight
        size={14}
        className="opacity-0 transition-opacity group-hover:opacity-50"
      />
    </Link>
  );
}
